module.exports = __webpack_public_path__ + "img/4.99af7521.jpg";